import { createSlice } from "@reduxjs/toolkit";

const boxSlice = createSlice({
  name: "box",
  initialState: {
    totalBoxes: 0,
  },
  reducers: {
    setTotalBoxes: (state, action) => {
      state.totalBoxes = action.payload;
    },
  },
});

export const { setTotalBoxes } = boxSlice.actions;
export default boxSlice.reducer;